import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { getSuperAdminClaim } from '@confluence/super-admin-claim';

import IsSuperAdminQuery, {
	type IsSuperAdminQuery$data,
	type IsSuperAdminQuery$variables,
} from './__generated__/IsSuperAdminQuery.graphql.ts';

/**
 * Preloads the query behind `useIsSuperAdmin`.
 *
 * `ViewPageGateway` wraps the whole page and renders `null` while `AdminKeyQuery` is loading, so
 * without this preload nothing below it makes it into the SSR output whenever the
 * `confluence.asSuperAdmin` claim cookie is set.
 *
 * `useIsSuperAdmin` skips the query unless that cookie exists, so this mirrors the same condition
 * and issues no request at all for everyone else.
 */
export async function preloadIsSuperAdmin(): Promise<
	| {
			data: IsSuperAdminQuery$data | null;
			errors?: ReadonlyArray<GraphQLErrorInterop>;
			hasErrors: boolean;
	  }
	| undefined
> {
	const { isLoggedIn } = getPreloaderFnContext();

	if (!isLoggedIn || !getSuperAdminClaim()) {
		return;
	}

	return query<IsSuperAdminQuery$data, IsSuperAdminQuery$variables>({
		query: IsSuperAdminQuery,
	});
}
